import React from 'react';
import { colors } from '@/styles';

import SyntaxHighlighter from 'react-syntax-highlighter';
import { github, githubGist, a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';

import * as Styled from './styled';

const CodeBlock: React.FC<{ language: string; code: string }> = ({ language, code }) => {
  return (
    <Styled.CodeBlock>
      <SyntaxHighlighter
        // showLineNumbers
        lineNumberContainerStyle={{ paddingRight: 20 }}
        lineNumberStyle={{ color: colors.secondary.lightGray3 }}
        language={language}
        style={githubGist}
      >
        {code}
      </SyntaxHighlighter>
    </Styled.CodeBlock>
  );
};

export default CodeBlock;
